import isPropValid from '@emotion/is-prop-valid';
import type { ReactElement } from 'react';
import { StyleSheetManager as SCStyleSheetManager } from 'styled-components';

import { IS_PRERENDER } from '#src/config.ts';

function shouldForwardProp(propName: string, target: any) {
  if (typeof target === 'string') {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName);
  }
  // For other elements, forward all props
  return true;
}

type Props = {
  children: ReactElement;
};

export const StyleSheetManager = ({ children }: Props) => {
  return (
    <SCStyleSheetManager
      disableCSSOMInjection={IS_PRERENDER}
      enableVendorPrefixes
      shouldForwardProp={shouldForwardProp}
    >
      {children}
    </SCStyleSheetManager>
  );
};
